// eslint-disable-next-line import/prefer-default-export
export const SIDEBAR = {
  module: {
    gestcom: 'Gestcom',
    patrimoine: 'Patrim',
    logistique: 'Logisti',
    comptabilite: 'Compta',
    baux: 'Baux',
    presse: 'Presse',
    achat: 'Achat',
    stock: 'Stock',
  },
  gestCom: {
    sales: 'Ventes',
    quotation: 'Devis',
    lignesDevis: 'Lignes Devis',
    remiseBancaire: 'Remises bancaires',
    journalReglements: 'Journal des règlements',
    order: 'Commandes',
    bill: 'Factures',
    lignesFacture: 'Lignes facture',
    customers: 'Clients',
    contacts: 'Contacts',
    produits: 'Produits',
    catalogue: 'Catalogue',
    reseauTempo: 'Réseau temporaire',
    Relances: 'Relances',
    planning: 'Planning',
    reseauTempoPlanning: 'Réseau tempo',
    reseauNum: 'Réseau numérique',
    ecranNum: 'Écran numérique',
    faceUnitaire: 'Face unitaire',
    reseauMairie: 'Réseau mairie',
    reseauLc: 'Réseau LC',
    reseauLcPlanning: 'Réseau LC',
    outils: 'Outils',
    reseauTempoDispo: 'Réseaux tempo disponibles',
    cartographie: 'Cartographie',
    relanceOption: 'Relance d\'option',
    face: 'Face unitaire',
    demande: 'Gestion des demandes',
    lignesCommande: 'Lignes commande',
    echeancePaiement: 'Échéances à payer',
    retrocession: 'Rétrocession',
    factor: 'Factor',
    transmission: 'Transmission',
    campagne: 'Campagne',
    salon: 'Salon',
    planMedia: 'Plan média',
    importIdelia: 'Import Idélia',
    autre: 'Autre',
    presse: 'Presse',
    parution: 'Gestion des parutions',
    sponsoring: 'Sponsoring / Événementiel',
    editionProduit: 'Edition produits',
    regroupementProduit: 'Regroupement de produit',
    suiviAffectations: 'Suivi d\'affectations',
  },
  patrimoine: {
    patrimoine: 'Patrimoine',
    emplacement: 'Emplacements',
    face: 'Faces',
    materiel: 'Matériels',
    dispositif: 'Dispositifs',
    collectivite: 'Collectivités',
    confrere: 'Confrères',
    tlpe: 'Tlpe',
    materielTlpe: 'Matériels',
    declaration: 'Déclarations',
    declarationAuFilDeLeau: "Déclarations au fil de l'eau",
    commandeTlpe: 'Historique TLPE',
    fournisseurMateriel: 'Fournisseur matériel',
    titreRecette: 'Titre de recette',
    paiement: 'Paiement',
    lotPaiement: 'Lot de paiement',
    JournalPaiement: 'Journal des paiements',
  },
  baux: {
    bailleur: 'Bailleurs',
    baux: 'Baux',
    contrat: 'Baux',
    constatationCharge: 'Constatation charges',
    echeancesAPayer: 'Paiement',
    depenseBailleur: 'Factures bailleur',
    lotPaiement: 'Lot de paiement',
    produitAchat: 'Produits',
    demarcheur: 'Démarcheurs',
    journalPaiements: 'Journal des paiements',
    commandeAchat: 'Commandes bailleur',
  },
  logistique: {
    logistiqueAff: 'Logistique affichage',
    logistiqueTech: 'Logistique technique',
    parametrage: 'Paramétrage',
    demandeIntervention: 'Demandes d\'intervention',
    demandeImpression: 'Demandes d\'impression',
    demandeAffectation: 'Demandes d\'affectations',
    tourneeAffichage: 'Liste d\'affichage',
    afficheur: 'Afficheurs',
    chargeTravailAff: 'Charge de travail',
    chargeTravailTech: 'Charge de travail',
    ordreTravailAff: 'Ordres de travail',
    ordreTravailTech: 'Ordres de travail',
    projets: 'Projets',
    technicien: 'Techniciens',
    listeAffectationLogistique: 'Affectation logistique',
    previsionnelDepart: 'Prévisionnel de départ',
    audit: 'Audits techniques',
    expedition: 'Expédition',
    ordreTravailImpression: 'OT Impression',
    suiviProduction: 'Suivi de production',
  },
  comptabilite: {
    excercicesComptable: 'Exercices comptables',
    journalEcriture: 'Journal',
    lotsComptable: 'Lots',
    ecritureComptable: 'Ecritures comptables',
    situation: 'Situation',
    moisComptable: 'Mois comptable',
    operationDiverse: 'OD',
  },
  presse: {
    parution: 'Gestion des parutions',
    marche: 'Marché',
    produits: 'Produits',
    salon: 'Salon',
  },
  achat: {
    marche: 'Marché',
    moduleMarche: 'Marché',
    fournisseurSupport: 'Fournisseur support',
    fournisseurs: 'Fournisseurs',
    lieuDeLivraison: 'Lieu de livraison',
    produits: 'Produits',
    achats: 'Achats',
    commandes: 'Commandes',
    ligneCommande: 'Lignes commande',
    bonReception: 'Bons de réception',
    factures: 'Factures',
    paiementsFactures: 'Paiements',
    journalPaiementsFactures: 'Journal paiements',
    lotPaiementFactures: 'Lot paiement',
    suiviAchats: 'Suivi des achats',
  },
  bonStock: {
    entreeMenu: 'Bons d\'entrée',
    sortieMenu: 'Bons de sortie',
  },
};
